import React from 'react';
import {Link} from "react-router-dom";

let date = new Date();

function Footer() {
    return (
        <>
        <footer className="bg-gray-800">

            <div className="container mx-auto pt-8 pb-4">

                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-x-4 gap-y-5">
                    <div>
                        <div className="flex flex-col justify-center items-center gap-2">
                            <p className="text-md text-gray-100">Trabaja con nosotros</p>
                            <a href="https://t.me/Happytaxi24" className="text-sm text-gray-400 hover:text-gray-100" target="_blank">Como chófer</a>
                            <a href="https://t.me/Happytaxi24" className="text-sm text-gray-400 hover:text-gray-100" target="_blank">Como gestor</a>
                        </div>
                    </div>

                    <div>
                        <div className="flex flex-col justify-center items-center gap-2">
                            <p className="text-md text-gray-100">Legal</p>
                            <a href="#" className="text-sm text-gray-400 hover:text-gray-100" target="_blank">Términos de uso</a>
                            <Link to="/politicas-de-privacidad" className="text-sm text-gray-400 hover:text-gray-100" target="_blank">Poíticas de privacidad</Link>
                        </div>
                    </div>

                    <div>
                        <div className="flex flex-col justify-center items-center gap-2">
                            <p className="text-md text-gray-100">Contátanos</p>
                            <a href="https://t.me/Happy_Taxi" className="text-sm text-gray-400 hover:text-gray-100" target="_blank">Telegram</a>
                            <a href="https://wa.me/+5352427601" className="text-sm text-gray-400 hover:text-gray-100" target="_blank">Whatsapp</a>
                        </div>
                    </div>
                </div>

                <div className="pt-10">
                    <p className="text-center text-gray-400 text-xs font-light">Copyright © Happy Taxi { date.getFullYear() }</p>
                </div>

            </div>
        </footer>
        </>
    );
}

export default Footer;